(function () {
  var SECTION_SELECTOR = '[data-ctr-main-product]';

  function parseVariants(section) {
    var node = section.querySelector('[data-ctr-mp-variants]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function getSwiper() {
    return window.Swiper || null;
  }

  function destroyGallery(section) {
    if (section._ctrMpSwiper) {
      section._ctrMpSwiper.destroy(true, true);
      section._ctrMpSwiper = null;
    }
  }

  function updateThumbs(section, index) {
    var thumbs = section.querySelectorAll('[data-ctr-mp-thumb]');
    thumbs.forEach(function (thumb, i) {
      var active = i === index;
      thumb.classList.toggle('is-active', active);
      if (active) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  function pauseSlideVideos(section, activeIndex) {
    section.querySelectorAll('[data-ctr-mp-slide]').forEach(function (slide, i) {
      if (i === activeIndex) return;
      slide.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });
    });
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-ctr-mp-gallery]');
    if (!gallery) return;

    var SwiperLib = getSwiper();
    var el = gallery.querySelector('[data-ctr-mp-swiper]');
    if (!SwiperLib || !el) return;

    destroyGallery(section);

    var prev = gallery.querySelector('[data-ctr-mp-prev]');
    var next = gallery.querySelector('[data-ctr-mp-next]');

    section._ctrMpSwiper = new SwiperLib(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      watchOverflow: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      on: {
        init: function (swiper) {
          updateThumbs(section, swiper.activeIndex);
          pauseSlideVideos(section, swiper.activeIndex);
        },
        slideChange: function (swiper) {
          updateThumbs(section, swiper.activeIndex);
          pauseSlideVideos(section, swiper.activeIndex);
        },
      },
    });

    if (gallery.dataset.ctrMpThumbsBound !== 'true') {
      gallery.dataset.ctrMpThumbsBound = 'true';
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest
          ? event.target.closest('[data-ctr-mp-thumb]')
          : null;
        if (!thumb || !gallery.contains(thumb)) return;
        var i = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(i) && section._ctrMpSwiper) {
          section._ctrMpSwiper.slideTo(i);
        }
      });
    }
  }

  function whenSwiperReady(cb) {
    if (getSwiper()) {
      cb();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (getSwiper() || tries > 40) {
        clearInterval(timer);
        if (getSwiper()) cb();
      }
    }, 50);
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var value = (Math.abs(cents) / 100).toFixed(2);
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(Math.abs(cents) / 100).toString();
    var template = format || '${{amount}}';

    return template
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function applyTemplate(template, values) {
    if (!template) return '';
    var percentLabel = String(values.savingPercent) + '%';
    return template
      .replace(/\[saving_percent\]%?/g, percentLabel)
      .replace(/\[saving\]%?/g, values.savingIsPercent ? percentLabel : values.savingMoney)
      .replace(/\[price\]/g, values.priceMoney);
  }

  function getPurchaseContext(section) {
    var purchase = section.querySelector('[data-ctr-mp-purchase]');
    if (!purchase) return null;

    var selectedBundle =
      section.querySelector('[data-ctr-mp-bundle].is-selected') ||
      section.querySelector('[data-ctr-mp-bundle]');

    return {
      root: purchase,
      selectedBundle: selectedBundle,
      bagsQty: Math.max(
        1,
        parseInt(
          selectedBundle && selectedBundle.getAttribute('data-bags-qty'),
          10
        ) || 1
      ),
      subscribeFrequency:
        (selectedBundle &&
          selectedBundle.getAttribute('data-subscribe-frequency')) ||
        purchase.getAttribute('data-ctr-mp-subscribe-frequency-fallback') ||
        '',
      saveBadgeTemplate: purchase.getAttribute('data-ctr-mp-save-badge-template') || '',
      perBagUnit: purchase.getAttribute('data-ctr-mp-per-bag-unit') || '/bag',
      moneyFormat: purchase.getAttribute('data-ctr-mp-money-format') || '${{amount}}',
    };
  }

  function updatePurchaseFrequency(section) {
    var ctx = getPurchaseContext(section);
    var purchaseFreq = section.querySelector('[data-ctr-mp-purchase-freq]');
    if (!purchaseFreq || !ctx) return;

    var frequency = ctx.subscribeFrequency || '';
    purchaseFreq.textContent = frequency;
    if (frequency) {
      purchaseFreq.removeAttribute('hidden');
    } else {
      purchaseFreq.setAttribute('hidden', '');
    }
  }

  function updatePurchasePrices(section, variantData) {
    updatePurchaseFrequency(section);
    if (!variantData) return;

    var ctx = getPurchaseContext(section);
    var otpCents = variantData.price || 0;
    var allocations = variantData.selling_plan_allocations || [];
    var subCents = allocations.length ? allocations[0].price : otpCents;
    var savingCents = Math.max(0, otpCents - subCents);
    var savingPercent =
      otpCents > 0 ? Math.round((savingCents * 100) / otpCents) : 0;
    var moneyFormat = ctx ? ctx.moneyFormat : '${{amount}}';
    var bagsQty = ctx ? ctx.bagsQty : 1;

    var savingMoney = formatMoney(savingCents, moneyFormat);
    var otpMoney = variantData.price_formatted || formatMoney(otpCents, moneyFormat);
    var subMoney =
      allocations.length && allocations[0].price_formatted
        ? allocations[0].price_formatted
        : otpMoney;
    var subPerBagMoney = formatMoney(Math.round(subCents / bagsQty), moneyFormat);
    var otpPerBagMoney = formatMoney(Math.round(otpCents / bagsQty), moneyFormat);

    var onetimePrice = section.querySelector('[data-ctr-mp-onetime-price]');
    if (onetimePrice) onetimePrice.textContent = otpMoney;

    var subscribePrice = section.querySelector('[data-ctr-mp-subscribe-price]');
    if (subscribePrice) subscribePrice.textContent = subMoney;

    var saveBadge = section.querySelector('[data-ctr-mp-save-badge]');
    if (saveBadge && ctx) {
      saveBadge.textContent = applyTemplate(ctx.saveBadgeTemplate, {
        savingPercent: savingPercent,
        savingMoney: savingMoney,
        savingIsPercent: true,
        priceMoney: subMoney,
      });
    }

    section.querySelectorAll('[data-ctr-mp-benefit-text]').forEach(function (el) {
      var template = el.getAttribute('data-template') || '';
      el.textContent = applyTemplate(template, {
        savingPercent: savingPercent,
        savingMoney: savingMoney,
        savingIsPercent: false,
        priceMoney: subMoney,
      });
    });

    var subPerBag = section.querySelector(
      '[data-ctr-mp-per-bag][data-purchase-type="subscribe"]'
    );
    if (subPerBag) {
      var subPriceEl = subPerBag.querySelector('[data-ctr-mp-per-bag-price]');
      if (subPriceEl) subPriceEl.textContent = subPerBagMoney;
    }

    var otpPerBag = section.querySelector(
      '[data-ctr-mp-per-bag][data-purchase-type="onetime"]'
    );
    if (otpPerBag) {
      var otpPriceEl = otpPerBag.querySelector('[data-ctr-mp-per-bag-price]');
      if (otpPriceEl) otpPriceEl.textContent = otpPerBagMoney;
    }

    var subscribeOption = section.querySelector(
      '[data-ctr-mp-purchase-option][data-purchase-type="subscribe"]'
    );
    if (subscribeOption) {
      if (allocations.length) {
        subscribeOption.setAttribute(
          'data-selling-plan-id',
          String(allocations[0].selling_plan_id)
        );
      } else {
        subscribeOption.setAttribute('data-selling-plan-id', '');
      }
    }
  }

  function setPurchaseType(section, type) {
    var options = section.querySelectorAll('[data-ctr-mp-purchase-option]');
    var sellingPlanInput = section.querySelector('[data-ctr-mp-selling-plan]');
    var selectedPlanId = '';

    options.forEach(function (option) {
      var active = option.getAttribute('data-purchase-type') === type;
      option.classList.toggle('is-selected', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) {
        selectedPlanId = option.getAttribute('data-selling-plan-id') || '';
      }
    });

    if (sellingPlanInput) {
      if (type === 'subscribe' && selectedPlanId) {
        sellingPlanInput.value = selectedPlanId;
        sellingPlanInput.removeAttribute('disabled');
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.setAttribute('disabled', 'disabled');
      }
    }
  }

  function selectBundle(section, button, variants) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var bundles = section.querySelectorAll('[data-ctr-mp-bundle]');
    bundles.forEach(function (bundle) {
      var active = bundle === button;
      bundle.classList.toggle('is-selected', active);
      bundle.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    var variantInput = section.querySelector('[data-ctr-mp-variant-id]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = button.getAttribute('data-available') === 'false';
    }

    var atc = section.querySelector('[data-ctr-mp-atc]');
    if (atc) {
      var available = button.getAttribute('data-available') !== 'false';
      atc.disabled = !available;
    }

    var variantData = variants[variantId];
    updatePurchasePrices(section, variantData);

    var selectedPurchase = section.querySelector(
      '[data-ctr-mp-purchase-option].is-selected'
    );
    var purchaseType = selectedPurchase
      ? selectedPurchase.getAttribute('data-purchase-type')
      : 'subscribe';
    setPurchaseType(section, purchaseType || 'subscribe');
  }

  function initBundles(section, variants) {
    var bundles = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-mp-bundle]')
    );
    if (!bundles.length) return;

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        selectBundle(section, bundle, variants);
      });
    });

    var selected =
      section.querySelector('[data-ctr-mp-bundle].is-selected') ||
      section.querySelector('[data-ctr-mp-bundle].ctr-main-product__bundle--featured') ||
      bundles[0];

    if (selected) {
      selectBundle(section, selected, variants);
    }
  }

  function initPurchase(section) {
    var options = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-mp-purchase-option]')
    );
    if (!options.length) return;

    options.forEach(function (option) {
      function activate() {
        setPurchaseType(section, option.getAttribute('data-purchase-type'));
      }
      option.addEventListener('click', activate);
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });

    var selected = section.querySelector(
      '[data-ctr-mp-purchase-option].is-selected'
    );
    setPurchaseType(
      section,
      selected ? selected.getAttribute('data-purchase-type') : 'subscribe'
    );
  }

  function setAccordionOpen(section, activeItem, forceOpen) {
    var items = section.querySelectorAll('[data-ctr-mp-accordion]');
    items.forEach(function (item) {
      var shouldOpen = item === activeItem && forceOpen === true;
      item.classList.toggle('is-open', shouldOpen);

      var trigger = item.querySelector('[data-ctr-mp-accordion-trigger]');
      var panel = item.querySelector('[data-ctr-mp-accordion-panel]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }
      if (panel) {
        panel.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      }
    });
  }

  function initAccordions(section) {
    if (section.dataset.ctrMpAccordionsReady === 'true') return;
    section.dataset.ctrMpAccordionsReady = 'true';

    var items = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-mp-accordion]')
    );

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ctr-mp-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        setAccordionOpen(section, item, !isOpen);
      });
    });
  }

  function getFormErrorNodes(section) {
    return {
      errorWrapper: section.querySelector('.product-form__error-message-wrapper'),
      errorMessage: section.querySelector('.product-form__error-message'),
    };
  }

  function setSubmitLoading(form, isLoading) {
    var submitButton = form.querySelector('[data-ctr-mp-atc]');
    var spinner = form.querySelector('.loading__spinner');

    if (submitButton) {
      if (isLoading) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      } else {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
    }
    if (spinner) {
      if (isLoading) spinner.classList.remove('hidden');
      else spinner.classList.add('hidden');
    }

    return submitButton;
  }

  function buildCartFormData(form) {
    var formData = new FormData(form);
    var sellingPlan = form.querySelector('[data-ctr-mp-selling-plan]');
    if (sellingPlan && sellingPlan.disabled) {
      formData.delete('selling_plan');
    }
    formData.delete('return_to');
    return formData;
  }

  function showFormError(section, message) {
    var nodes = getFormErrorNodes(section);
    if (nodes.errorWrapper && nodes.errorMessage) {
      nodes.errorMessage.textContent = message || 'Unable to add to cart.';
      nodes.errorWrapper.removeAttribute('hidden');
    }
  }

  function clearFormError(section) {
    var nodes = getFormErrorNodes(section);
    if (nodes.errorWrapper) nodes.errorWrapper.setAttribute('hidden', '');
  }

  function initDrawerSubmit(section) {
    var afterAdd = section.getAttribute('data-ctr-mp-after-add') || 'notification';
    if (afterAdd !== 'drawer') return;

    var form = section.querySelector('form.ctr-main-product__form');
    if (!form || form.dataset.ctrMpDrawerReady === 'true') return;
    form.dataset.ctrMpDrawerReady = 'true';

    var atc = form.querySelector('[data-ctr-mp-atc]');
    if (atc) atc.setAttribute('aria-haspopup', 'dialog');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var cartDrawer = document.querySelector('cart-drawer');
      var submitButton = form.querySelector('[data-ctr-mp-atc]');
      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

      setSubmitLoading(form, true);
      clearFormError(section);

      var formData = buildCartFormData(form);

      if (
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender === 'function'
      ) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (item) {
            return item.id;
          })
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      fetch(window.routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            showFormError(
              section,
              result.data.description || result.data.message || 'Unable to add to cart.'
            );
            return;
          }

          if (
            cartDrawer &&
            typeof cartDrawer.renderContents === 'function' &&
            result.data.sections
          ) {
            if (cartDrawer.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
            cartDrawer.renderContents(result.data);
            return;
          }

          window.location.href =
            section.getAttribute('data-ctr-mp-cart-url') || '/cart';
        })
        .catch(function () {
          showFormError(section, 'Unable to add to cart.');
        })
        .finally(function () {
          setSubmitLoading(form, false);
        });
    });
  }

  function clearCart() {
    return fetch((window.routes.cart_url || '/cart') + '/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    });
  }

  function addToCart(formData) {
    return fetch(window.routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    });
  }

  function initRedirectSubmit(section) {
    var afterAdd = section.getAttribute('data-ctr-mp-after-add') || 'notification';
    if (afterAdd !== 'cart' && afterAdd !== 'checkout') return;

    var form = section.querySelector('form.ctr-main-product__form');
    if (!form || form.dataset.ctrMpRedirectReady === 'true') return;
    form.dataset.ctrMpRedirectReady = 'true';

    var cartUrl = section.getAttribute('data-ctr-mp-cart-url') || '/cart';
    var checkoutUrl = section.getAttribute('data-ctr-mp-checkout-url') || '/checkout';
    var redirectUrl = afterAdd === 'checkout' ? checkoutUrl : cartUrl;
    var shouldClearCart = afterAdd === 'checkout';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submitButton = form.querySelector('[data-ctr-mp-atc]');
      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

      setSubmitLoading(form, true);
      clearFormError(section);

      var formData = buildCartFormData(form);
      var prepare = shouldClearCart
        ? clearCart().then(function (clearResult) {
            if (!clearResult.ok) {
              throw new Error('Unable to clear cart.');
            }
          })
        : Promise.resolve();

      prepare
        .then(function () {
          return addToCart(formData);
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            showFormError(
              section,
              result.data.description || result.data.message || 'Unable to add to cart.'
            );
            return;
          }
          window.location.href = redirectUrl;
        })
        .catch(function (error) {
          showFormError(
            section,
            (error && error.message) || 'Unable to add to cart.'
          );
        })
        .finally(function () {
          setSubmitLoading(form, false);
        });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.ctrMpReady === 'true') return;
    section.dataset.ctrMpReady = 'true';

    var variants = parseVariants(section);
    whenSwiperReady(function () {
      initGallery(section);
    });
    initBundles(section, variants);
    initPurchase(section);
    initAccordions(section);
    initDrawerSubmit(section);
    initRedirectSubmit(section);
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrMpReady;
    delete section.dataset.ctrMpAccordionsReady;
    var form = section.querySelector('form.ctr-main-product__form');
    if (form) {
      delete form.dataset.ctrMpRedirectReady;
      delete form.dataset.ctrMpDrawerReady;
    }
    whenSwiperReady(function () {
      initSection(section);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    destroyGallery(section);
    delete section.dataset.ctrMpReady;
    delete section.dataset.ctrMpAccordionsReady;
    var gallery = section.querySelector('[data-ctr-mp-gallery]');
    if (gallery) delete gallery.dataset.ctrMpThumbsBound;
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest
      ? event.target.closest('[data-ctr-mp-accordion]')
      : null;
    if (!item) return;
    var section = item.closest(SECTION_SELECTOR);
    if (!section) return;
    setAccordionOpen(section, item, true);
  });
})();
